var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grey-text text-lighten-3",attrs:{"id":"app"}},[_c('navigation-view'),_c('router-view'),_c('footer-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }